/*
 * @Author: 田鑫
 * @Date: 2022-01-17 18:27:55
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-17 18:29:27
 * @Description:
 */
export default [
  {
    name: "wuMeiManagement",
    path: "/platformManagement/wuMeiManagement/list",
    meta: { title: "物美优选" },
    component: require("business/platformManagement/wuMeiManagement/list.vue")
      .default
  }
];
